import React, { useState } from 'react';
import ReactLoading from 'react-loading';
import FieldQty from '../fields/FieldQty';
import CartImage from '../common/CartImage';
// import PropTypes from 'prop-types';
import LocalizedMessage from 'react-l10n';
import Numeral from 'numeral';
import $ from 'jquery';
import {
    getCartItemTotalPrice,
    getFinalBuyableLink,
} from '../../selectors/cartSelector';
import { currencyDisplay, __currencyDisplay } from '../../_utils';
import { calculateNearestCartQty } from '../../selectors/tagWizardSelector';
import classnames from 'classnames';

function CartSummaryItem(props) {
    const {
        item,
        removeItem,
        updateQuantity,
        finaliseQuantity,
        isRowLoading,
        currencyFormat,
        currencyDisplayCode,
        locale,
        itemQty,
        openNoteModal,
    } = props;
    const {
        ID,
        InternalItemID,
        Title,
        IsCustomTag,
        UnitPrice,
        TotalUnitItems,
        TotalPrice,
        TotalPriceWithoutTax,
        MinOrderQuantity = 1,
        SellByPackageOnly = false,
        Notes = '',
        ParentItemID,
        CanEditQuantity = true,
        CanDelete = true,
    } = item;



    console.log("ItemID ====================>", ID);
    console.log("Parent Item ID ================++>", ParentItemID);

    const [isToBeRemoved, setIsToBeRemoved] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const cartModalItemKey = `cart-summary-item-${ID}`;
    const finalBuyableLink = getFinalBuyableLink(item);
    const canAddNotes =
        typeof ParentItemID == 'undefined' ||
        ParentItemID == null ||
        ParentItemID <= 0;
    const packSize = MinOrderQuantity;

    const handleConfirmRemove = (e) => {
        if (CanDelete === true) {
            if (!isRowLoading && !isDeleting) {
                setIsDeleting(true);
                removeItem(item, {
                    success: () => {
                        $(`#${cartModalItemKey}`).slideUp();
                    },
                    always: () => {
                        setIsDeleting(false);
                    },
                });
            }
        }
    };

    const handleQuantityUpdate = (target, newValue) => {
        if (!isDeleting) {
            updateQuantity(ID, newValue);
        }
    };

    const handleControlQuantityUpdate = (target, newValue) => {
        if (!isDeleting) {
            const finalCartQty = calculateNearestCartQty(
                SellByPackageOnly,
                newValue,
                packSize,
                MinOrderQuantity
            );
            finaliseQuantity(ID, finalCartQty);
        }
    };

    const finaliseQuantityUpdate = () => {
        if (!isDeleting) {
            const finalCartQty = calculateNearestCartQty(
                SellByPackageOnly,
                TotalUnitItems,
                packSize,
                MinOrderQuantity
            );
            finaliseQuantity(ID, finalCartQty);
        }
    };
    const handleOpenNoteModal = (e) => {
        e.preventDefault();
        openNoteModal(ID);
    };

    return (
        <div
            className={classnames(
                'data-table__tr-group cart-summary__tr-group',
                isToBeRemoved === true && 'data-table__tr-group--removing',
                ParentItemID > 0 && 'dt-cart-summary--sub'
            )}
            id={cartModalItemKey}
        >
            <div className='cart-summary__indent'>
                <span className='icon-indent-arrow'></span>
            </div>
            <div className='data-table__tr cart-summary__tr'>
                <div className='data-table__td dt-cart-summary__image'>
                    <CartImage item={item} />
                </div>
                <div className='data-table__td dt-cart-summary__product'>
                    <span className='data-table__info data-table__info--default'>
                        <span className='product__code'>{InternalItemID}</span>
                        <div className='product__general-title'>{Title}</div>
                        {IsCustomTag === true && (
                            <a
                                href={finalBuyableLink}
                                className='button button--green button--icon button--icon--edit cart-summary__label hidden-xs hidden-sm'
                            >
                                <LocalizedMessage id={'CUSTOM_TAG_TO_EDIT'} />
                            </a>
                        )}

                        {canAddNotes === true && (
                            <div className='cart-summary__notes-container'>
                                {Notes == '' || Notes == null ? (
                                    <button
                                        className='button-link-plain button-link-plain--small button-link-plain--icon'
                                        type='button'
                                        onClick={handleOpenNoteModal}
                                    >
                                        <span className='icon icon-notes'></span>
                                        <span>
                                            <LocalizedMessage
                                                id={'FIELD.ADD_NOTE'}
                                            />
                                        </span>
                                    </button>
                                ) : (
                                    <div
                                        className='cart-summary__notes'
                                        onClick={handleOpenNoteModal}
                                    >
                                        <span className='icon icon-notes'></span>
                                        <textarea
                                            className=''
                                            readOnly='readonly'
                                            value={Notes}
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </span>
                </div>
                <div className='data-table__td dt-cart-summary__price text-box--right hidden-xs hidden-sm'>
                    <span className='react-table__info'>
                        {currencyDisplay(
                            UnitPrice,
                            currencyDisplayCode,
                            currencyFormat,
                            locale
                        )}
                    </span>
                </div>
                <div className='data-table__td dt-cart-summary__quantity hidden-xs hidden-sm'>
                    {IsCustomTag === true || CanEditQuantity !== true ? (
                        <span className='data-table__info'>
                            {Numeral(itemQty).format('0,0')}
                        </span>
                    ) : (
                        <FieldQty
                            required
                            disabled={
                                isRowLoading ||
                                (window.localeCountry == 'South Africa' &&
                                    window.currentOrderPaymentMethod ==
                                    'order-card-authorization-payfast' &&
                                    window.isEditOrder)
                            }
                            isDisabled={
                                window.localeCountry == 'South Africa' &&
                                window.currentOrderPaymentMethod ==
                                'order-card-authorization-payfast' &&
                                window.isEditOrder
                            }
                            isLoading={isRowLoading}
                            name='TotalUnitItems'
                            value={TotalUnitItems || 1}
                            min={MinOrderQuantity}
                            step={
                                SellByPackageOnly === true
                                    ? MinOrderQuantity
                                    : 1
                            }
                            onChange={handleQuantityUpdate}
                            onControlClick={handleControlQuantityUpdate}
                            onBlur={finaliseQuantityUpdate}
                        />
                    )}
                </div>
                <div className='data-table__td dt-cart-summary__total hidden-xs hidden-sm'>
                    <span className='data-table__info'>
                        {currencyDisplay(
                            getCartItemTotalPrice(
                                TotalPrice,
                                TotalPriceWithoutTax
                            ),
                            currencyDisplayCode,
                            currencyFormat,
                            locale
                        )}
                    </span>
                </div>
                {window.localeCountry == 'South Africa' &&
                    window.currentOrderPaymentMethod ==
                    'order-card-authorization-payfast' &&
                    window.isEditOrder ? (
                    <div style={{ maxWidth: 45 }}></div>
                ) : (
                    <div
                        className='data-table__td text-box--right'
                        style={{ maxWidth: 45 }}
                    >
                        <span className='data-table__info data-table__info--default'>
                            <button
                                type='button'
                                className='button-link-plain button-link-plain--big'
                                onClick={() =>
                                    CanDelete === true && setIsToBeRemoved(true)
                                }
                                style={{ opacity: CanDelete === true ? 1 : 0 }}
                            >
                                <i className='icon icon-bin-thick' />
                            </button>
                        </span>
                    </div>
                )}
            </div>
            <div className='cart-summary__extra-data visible-xs visible-sm'>
                {IsCustomTag === true && (
                    <a
                        href={finalBuyableLink}
                        className='cart-list__label cart-list__label--block'
                    >
                        <LocalizedMessage id={'CUSTOM_TAG_TO_EDIT'} />
                    </a>
                )}

                <div className='cart-summary__info-box'>
                    <div className='row'>
                        <div className='col-xs-4'>
                            <div className='data-table__heading data-table__heading--block'>
                                <LocalizedMessage id={'PRICE'} />
                            </div>
                            <div className='cart-summary__info'>
                                {currencyDisplay(
                                    UnitPrice,
                                    currencyDisplayCode,
                                    currencyFormat,
                                    locale
                                )}
                            </div>
                        </div>
                        <div className='col-xs-4'>
                            <div className='data-table__heading data-table__heading--block'>
                                <LocalizedMessage id={'QUANTITY'} />
                            </div>
                            {IsCustomTag === true ||
                                CanEditQuantity !== true ? (
                                <span className='cart-summary__info'>
                                    {Numeral(TotalUnitItems).format('0,0')}
                                </span>
                            ) : (
                                <FieldQty
                                    required
                                    isLoading={isRowLoading}
                                    disabled={isRowLoading}
                                    name='TotalUnitItems'
                                    value={TotalUnitItems || 1}
                                    min={MinOrderQuantity}
                                    step={
                                        SellByPackageOnly === true
                                            ? MinOrderQuantity
                                            : 1
                                    }
                                    onChange={handleQuantityUpdate}
                                    onControlClick={handleControlQuantityUpdate}
                                    onBlur={finaliseQuantityUpdate}
                                />
                            )}
                        </div>
                        <div className='col-xs-4'>
                            <div className='data-table__heading data-table__heading--block'>
                                Total
                            </div>
                            <div className='cart-summary__info'>
                                {currencyDisplay(
                                    getCartItemTotalPrice(
                                        TotalPrice,
                                        TotalPriceWithoutTax
                                    ),
                                    currencyDisplayCode,
                                    currencyFormat,
                                    locale
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='data-table__confirm'>
                <div className='data-table__confirm__text'>
                    <LocalizedMessage id={'REMOVE_ITEM_FROM_CART'} />
                </div>
                <div className='data-table__confirm__button-group'>
                    <button
                        type='button'
                        className='data-table__confirm__button'
                        onClick={() => setIsToBeRemoved(false)}
                    >
                        <LocalizedMessage id={'CANCEL'} />
                    </button>
                    <button
                        type='button'
                        className='data-table__confirm__button data-table__confirm__button--green data-table__confirm__button--uppercase'
                        onClick={handleConfirmRemove}
                        style={{ position: 'relative' }}
                    >
                        {isDeleting == true && (
                            <ReactLoading
                                type='spin'
                                className='button__spinner'
                                color='black'
                                height={20}
                                width={20}
                            />
                        )}
                        <span style={{ opacity: isDeleting ? 0 : 1 }}>
                            <LocalizedMessage id={'CONFIRM'} />
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
}

// default props
CartSummaryItem.defaultProps = {
    // message: '',
};
// validate props
CartSummaryItem.propTypes = {
    // message: PropTypes.string,
};

export default CartSummaryItem;
